import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, toConsumableArray as _toConsumableArray, extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { useCallback } from 'react';
import { FormItem, FormLabel, FormInputDropdown } from '@tesla/design-system-react';
import { useField } from 'informed';
import { FeedBack } from './Feedback.js';

var _excluded = ["label", "feedback", "helper", "caption", "tooltip", "multiple", "keepArray", "showFullLabel"],
  _excluded2 = ["id", "disabled", "readonly"];
var Dropdown = function Dropdown(props) {
  var _useField = useField(_objectSpread2({}, props)),
    fieldState = _useField.fieldState,
    fieldApi = _useField.fieldApi,
    render = _useField.render,
    userProps = _useField.userProps,
    ref = _useField.ref;
  var label = userProps.label,
    feedback = userProps.feedback,
    helper = userProps.helper,
    caption = userProps.caption,
    tooltip = userProps.tooltip,
    multiple = userProps.multiple,
    keepArray = userProps.keepArray,
    showFullLabel = userProps.showFullLabel,
    inputProps = _objectWithoutProperties(userProps, _excluded);
  var id = inputProps.id,
    disabled = inputProps.disabled,
    readonly = inputProps.readonly,
    restInputProps = _objectWithoutProperties(inputProps, _excluded2);
  var showError = fieldState.showError,
    error = fieldState.error,
    value = fieldState.value;
  var setValue = fieldApi.setValue,
    setTouched = fieldApi.setTouched,
    setFocused = fieldApi.setFocused,
    getValue = fieldApi.getValue;
  var v = value || (multiple ? [] : '');
  var onOptionSelect = useCallback(function (s) {
    var current = getValue() || (multiple ? [] : '');

    // If we already have value then remove ( it was clicked again )
    var selected;
    if (multiple ? current.find(function (val) {
      return s.value === val;
    }) : current === s.value) {
      // Remove from array or return nothing
      selected = multiple ? current.filter(function (v) {
        return v !== s.value;
      }) : undefined;

      // If nothing left remove value
      if (selected && selected.length === 0 && !keepArray) {
        selected = undefined;
      }
    }
    // This is new value so set!
    else {
      selected = multiple ? [].concat(_toConsumableArray(current), [s.value]) : s.value;
    }
    setValue(selected);
  }, [multiple, inputProps.name]);
  var onClear = useCallback(function () {
    if (!keepArray) {
      setValue(multiple ? undefined : '');
    } else {
      setValue(multiple ? [] : '');
    }
  }, []);
  var multipleSelectedLabelFull = showFullLabel ? showFullLabel(v) : undefined;
  return render( /*#__PURE__*/React.createElement(FormItem, {
    error: showError,
    variant: "text",
    disabled: disabled,
    readOnly: readonly
  }, label ? /*#__PURE__*/React.createElement(FormLabel, {
    htmlFor: id,
    caption: caption,
    tooltip: tooltip
  }, label) : null, /*#__PURE__*/React.createElement(FormInputDropdown, _extends({}, restInputProps, {
    id: id,
    disabled: disabled,
    selected: v,
    onOptionSelect: onOptionSelect,
    onClear: onClear,
    onBlur: function onBlur(e) {
      setTouched(true, e);
    },
    onFocus: function onFocus(e) {
      setFocused(true, e);
    },
    readOnly: readonly,
    inputRef: ref,
    "aria-invalid": showError,
    "aria-describedby": "".concat(id, "-feedback"),
    multipleSelectedLabelFull: multipleSelectedLabelFull
  })), /*#__PURE__*/React.createElement(FeedBack, {
    feedback: feedback,
    helper: helper,
    error: error,
    showError: showError,
    id: "".concat(id, "-feedback")
  })));
};

export { Dropdown };
